/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./src/js/main.js":
/*!************************!*\
  !*** ./src/js/main.js ***!
  \************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var ButtonKlaviyoHandler = /*#__PURE__*/function (_HTMLElement) {
  _inherits(ButtonKlaviyoHandler, _HTMLElement);
  var _super = _createSuper(ButtonKlaviyoHandler);
  function ButtonKlaviyoHandler() {
    _classCallCheck(this, ButtonKlaviyoHandler);
    return _super.call(this);
  }
  _createClass(ButtonKlaviyoHandler, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.addEventListener('click', this.handleClick.bind(this));
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      this.removeEventListener('click', this.handleClick.bind(this));
    }
  }, {
    key: "handleClick",
    value: function handleClick() {
      console.log('Button clicked!');

      // Get form codes from data attributes
      var desktopFormCode = this.getAttribute('data-desktop-code') || 'Wcj4rs';
      var mobileFormCode = this.getAttribute('data-mobile-form-code') || desktopFormCode;

      // Detect if device is mobile
      var isMobile = window.innerWidth <= 768 || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

      // Select appropriate form code based on device
      var formCode = isMobile ? mobileFormCode : desktopFormCode;
      console.log('Device type:', isMobile ? 'Mobile' : 'Desktop');
      console.log('Opening Klaviyo form:', formCode);

      // Open Klaviyo form
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', formCode]);
    }
  }]);
  return ButtonKlaviyoHandler;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
var ButtonDownloadEBookHandler = /*#__PURE__*/function (_HTMLElement2) {
  _inherits(ButtonDownloadEBookHandler, _HTMLElement2);
  var _super2 = _createSuper(ButtonDownloadEBookHandler);
  function ButtonDownloadEBookHandler() {
    _classCallCheck(this, ButtonDownloadEBookHandler);
    return _super2.call(this);
  }
  _createClass(ButtonDownloadEBookHandler, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.addEventListener('click', this.handleClick);
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
    }
  }, {
    key: "handleClick",
    value: function handleClick() {
      console.log('Download E-Book button clicked!');
      window._klOnsite = window._klOnsite || [];
      // You can replace 'YOUR_EBOOK_FORM_ID' with the actual Klaviyo form ID for the e-book
      window._klOnsite.push(['openForm', 'RLQg99']);
    }
  }]);
  return ButtonDownloadEBookHandler;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('button-klaviyo-handler', ButtonKlaviyoHandler);
customElements.define('button-download-ebook-handler', ButtonDownloadEBookHandler);

/**
 * GoldEngravingBlock — Web Component
 *
 * Two visual states:
 *  – unchecked : simple row with animated checkbox + label
 *  – checked   : expanded panel with price, text input, character counter & note
 *
 * Cart behaviour:
 *  – Injects a hidden properties[<label>] input into the ATC form so the
 *    engraving text travels with the MAIN product as a line item property.
 *  – On theme:cart:added: fetches /cart.js → counts how many items carry the
 *    engraving property → sets the engraving PRODUCT variant qty to that
 *    count via /cart/update.js.  The update.js response is used to verify.
 */
var GoldEngravingBlock = /*#__PURE__*/function (_HTMLElement3) {
  _inherits(GoldEngravingBlock, _HTMLElement3);
  var _super3 = _createSuper(GoldEngravingBlock);
  function GoldEngravingBlock() {
    var _this;
    _classCallCheck(this, GoldEngravingBlock);
    _this = _super3.call(this);
    _this._checked = false;
    _this._engravingText = '';
    _this._onCartAdded = null;
    _this._ownUpdate = false;
    _this._hiddenInput = null;
    _this._variantIdInput = null; // hidden _engraving_variant_id input
    _this._free = false; // skip adding engraving product to cart
    return _this;
  }
  _createClass(GoldEngravingBlock, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._variantId = this.getAttribute('data-engraving-variant-id') || '';
      this._maxChars = parseInt(this.getAttribute('data-max-chars'), 10) || 15;
      this._propertyName = this.getAttribute('data-property-name') || 'Engraving';
      this._free = this.getAttribute('data-free') === 'true';

      // DOM refs
      this._panel = this.querySelector('[data-engraving-panel]');
      this._checkbox = this.querySelector('[data-engraving-checkbox]');
      this._input = this.querySelector('[data-engraving-input]');
      this._counter = this.querySelector('[data-engraving-count]');

      // Find the product ATC form (sibling block inside the same wrapper)
      var wrapper = this.closest('.product-single__wrapper') || this.closest('[data-section-id]');
      this._form = wrapper ? wrapper.querySelector('form[data-product-form]') : null;
      if (!this._panel || !this._checkbox) return;

      // Start collapsed
      this._panel.setAttribute('aria-hidden', 'true');

      // Checkbox change events
      this._checkbox.addEventListener('change', this._onCheckboxChange.bind(this));

      // Text input counter
      if (this._input) {
        this._input.addEventListener('input', this._onTextInput.bind(this));
      }

      // React to every theme cart rebuild
      this._onCartAdded = this._onThemeCartAdded.bind(this);
      document.addEventListener('theme:cart:added', this._onCartAdded);
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      if (this._onCartAdded) {
        document.removeEventListener('theme:cart:added', this._onCartAdded);
      }
      this._removeHiddenInput();
    }

    // -------------------------------------------------------------------------
  }, {
    key: "_onCheckboxChange",
    value: function _onCheckboxChange(e) {
      this._checked = e.currentTarget.checked;
      if (this._checkbox) this._checkbox.checked = this._checked;
      if (this._checked) {
        this._openPanel();
      } else {
        this._closePanel();
        this._syncEngravingQty();
      }
    }
  }, {
    key: "_onTextInput",
    value: function _onTextInput() {
      this._engravingText = this._input.value || '';
      if (this._counter) this._counter.textContent = this._engravingText.length;
      this._updateHiddenInput();
    }

    // -------------------------------------------------------------------------
  }, {
    key: "_openPanel",
    value: function _openPanel() {
      var _this2 = this;
      if (!this._panel) return;
      this._panel.setAttribute('aria-hidden', 'false');
      this._panel.classList.add('is-open');
      this._updateHiddenInput();
      if (this._input) setTimeout(function () {
        return _this2._input.focus();
      }, 50);
    }
  }, {
    key: "_closePanel",
    value: function _closePanel() {
      if (!this._panel) return;
      this._panel.setAttribute('aria-hidden', 'true');
      this._panel.classList.remove('is-open');
      if (this._input) this._input.value = '';
      if (this._counter) this._counter.textContent = '0';
      this._engravingText = '';
      this._removeHiddenInput();
    }

    // -------------------------------------------------------------------------
    // Hidden input management — attaches engraving text to the main product
    // -------------------------------------------------------------------------
  }, {
    key: "_updateHiddenInput",
    value: function _updateHiddenInput() {
      if (!this._form) return;

      // Engraving text property (visible to customer)
      if (!this._hiddenInput) {
        this._hiddenInput = document.createElement('input');
        this._hiddenInput.type = 'hidden';
        this._hiddenInput.name = 'properties[' + this._propertyName + ']';
        this._form.appendChild(this._hiddenInput);
      }
      this._hiddenInput.value = this._engravingText;

      // Variant tracking property — name starts with _ so Shopify hides it from
      // customers. Links this cart item back to the engraving fee product so the
      // sync logic can correctly attribute quantities across multiple engraving
      // products. Skipped when engraving is free (no fee product in cart).
      if (!this._free && this._variantId) {
        if (!this._variantIdInput) {
          this._variantIdInput = document.createElement('input');
          this._variantIdInput.type = 'hidden';
          this._variantIdInput.name = 'properties[_engraving_variant_id]';
          this._form.appendChild(this._variantIdInput);
        }
        this._variantIdInput.value = this._variantId;
      }
    }
  }, {
    key: "_removeHiddenInput",
    value: function _removeHiddenInput() {
      if (this._hiddenInput && this._hiddenInput.parentNode) {
        this._hiddenInput.parentNode.removeChild(this._hiddenInput);
      }
      this._hiddenInput = null;
      if (this._variantIdInput && this._variantIdInput.parentNode) {
        this._variantIdInput.parentNode.removeChild(this._variantIdInput);
      }
      this._variantIdInput = null;
    }

    // -------------------------------------------------------------------------
    /**
     * Called on every theme:cart:added (theme CartDrawer rebuild).
     * If this is our own update → skip to prevent infinite loop.
     * Otherwise → sync engraving product qty with the number of cart items
     * that carry the engraving property.
     */
  }, {
    key: "_onThemeCartAdded",
    value: function _onThemeCartAdded() {
      if (this._ownUpdate) {
        this._ownUpdate = false;
        return;
      }
      this._syncEngravingQty();
    }

    // -------------------------------------------------------------------------
    /**
     * Fetch /cart.js → count items with the engraving property →
     * POST /cart/update.js to set the engraving variant qty to that count.
     * Then call window.cart.getCart() to refresh the cart drawer properly.
     */
  }, {
    key: "_syncEngravingQty",
    value: function _syncEngravingQty() {
      var _this3 = this;
      // Free engraving: no fee product to sync
      if (!this._variantId || this._free) return;
      fetch('/cart.js', {
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      }).then(function (res) {
        return res.json();
      }).then(function (cart) {
        // Count items that carry the hidden _engraving_variant_id pointing
        // at this specific engraving variant. Supports multiple engraving
        // products on the same store (each main item points to its own variant).
        var count = cart.items.reduce(function (sum, item) {
          if (String(item.variant_id) === String(_this3._variantId)) return sum;
          var props = item.properties || {};
          if (String(props['_engraving_variant_id'] || '') === String(_this3._variantId)) {
            return sum + item.quantity;
          }
          return sum;
        }, 0);
        _this3._ownUpdate = true;
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            updates: _defineProperty({}, _this3._variantId, count)
          })
        });
      }).then(function (res) {
        if (!res.ok) throw new Error('Cart update failed');
        return res.json();
      }).then(function (cart) {
        // Verify from response
        var engravingItem = cart.items.find(function (item) {
          return String(item.variant_id) === String(_this3._variantId);
        });
        var engravingQty = engravingItem ? engravingItem.quantity : 0;

        // If no engraving items remain and checkbox is still checked, reset UI
        if (engravingQty === 0 && _this3._checked) {
          _this3._checked = false;
          if (_this3._checkbox) _this3._checkbox.checked = false;
          _this3._closePanel();
        }

        // Only refresh the cart drawer if it's already open — getCart()
        // calls build() which calls openCartDrawer(), so calling it when
        // the drawer is closed would open it unexpectedly.
        if (window.cart && typeof window.cart.getCart === 'function') {
          if (document.body.classList.contains('js-drawer-open-cart')) {
            window.cart.getCart();
          }
        }
      })["catch"](function () {
        _this3._ownUpdate = false;
      });
    }
  }]);
  return GoldEngravingBlock;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('gold-engraving-block', GoldEngravingBlock);

/**
 * Standalone cart sync — keeps engraving product quantities in sync whenever
 * the cart is rebuilt. Supports multiple engraving products on the same store.
 *
 * Strategy:
 *  1. Find all engraving fee products in cart by handle (/engrav/i).
 *  2. For each, count main items whose hidden _engraving_variant_id property
 *     points to that variant. Items with free engraving carry no such property
 *     and are therefore ignored automatically.
 *  3. Patch any mismatches (including setting qty to 0 when all references
 *     are gone, e.g. after item removal).
 */
(function () {
  var syncing = false;
  document.addEventListener('theme:cart:added', function () {
    // Skip if the web component is handling its own sync
    if (document.querySelector('gold-engraving-block[data-engraving-variant-id]')) return;
    if (syncing) return;
    syncing = true;
    fetch('/cart.js', {
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then(function (res) {
      return res.json();
    }).then(function (cart) {
      // Step 1: Identify engraving fee products by handle (supports multiple)
      var engravingItems = {}; // variantId → currentQty
      for (var i = 0; i < cart.items.length; i++) {
        var item = cart.items[i];
        if (/engrav/i.test(item.handle || '')) {
          engravingItems[String(item.variant_id)] = item.quantity;
        }
      }
      if (Object.keys(engravingItems).length === 0) {
        syncing = false;
        return;
      }

      // Step 2: Count expected qty for each via _engraving_variant_id
      // (free-engraving items have no such property → don't contribute)
      var expectedQtys = {};
      for (var variantId in engravingItems) {
        expectedQtys[variantId] = 0; // default: 0 if nothing references it
      }

      for (var i = 0; i < cart.items.length; i++) {
        var item = cart.items[i];
        var props = item.properties || {};
        var evId = String(props['_engraving_variant_id'] || '');
        if (evId && expectedQtys.hasOwnProperty(evId) && String(item.variant_id) !== evId) {
          expectedQtys[evId] += item.quantity;
        }
      }

      // Step 3: Build updates object for mismatches only
      var updates = {};
      for (var variantId in expectedQtys) {
        if (engravingItems[variantId] !== expectedQtys[variantId]) {
          updates[variantId] = expectedQtys[variantId];
        }
      }
      if (Object.keys(updates).length === 0) {
        syncing = false;
        return;
      }
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          updates: updates
        })
      }).then(function () {
        syncing = false;
        if (window.cart && typeof window.cart.getCart === 'function') {
          if (document.body.classList.contains('js-drawer-open-cart')) {
            window.cart.getCart();
          }
        }
      })["catch"](function () {
        syncing = false;
      });
    })["catch"](function () {
      syncing = false;
    });
  });
})();

/**
 * Checkout guard — verifies the engraving product qty matches the number of
 * engraved line items before the cart form submits to checkout.
 * Runs as a standalone document listener so it works regardless of whether
 * the GoldEngravingBlock web component is present on the current page.
 */
document.addEventListener('DOMContentLoaded', function () {
  var checkoutVerified = false;
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('form[data-cart-form]')) return;
    var submitter = e.submitter;
    if (!submitter || submitter.name !== 'checkout') return;

    // Second pass after fix — let it through
    if (checkoutVerified) {
      checkoutVerified = false;
      return;
    }
    e.preventDefault();
    fetch('/cart.js', {
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then(function (res) {
      return res.json();
    }).then(function (cart) {
      // Step 1: Find all engraving fee products in cart by handle
      var engravingItems = {}; // variantId → currentQty
      for (var i = 0; i < cart.items.length; i++) {
        var item = cart.items[i];
        if (/engrav/i.test(item.handle || '')) {
          engravingItems[String(item.variant_id)] = item.quantity;
        }
      }

      // No fee products in cart — proceed to checkout
      if (Object.keys(engravingItems).length === 0) {
        checkoutVerified = true;
        submitter.click();
        return;
      }

      // Step 2: Count expected qty via _engraving_variant_id
      var expectedQtys = {};
      for (var variantId in engravingItems) {
        expectedQtys[variantId] = 0;
      }
      for (var i = 0; i < cart.items.length; i++) {
        var item = cart.items[i];
        var props = item.properties || {};
        var evId = String(props['_engraving_variant_id'] || '');
        if (evId && expectedQtys.hasOwnProperty(evId) && String(item.variant_id) !== evId) {
          expectedQtys[evId] += item.quantity;
        }
      }

      // Step 3: Find mismatches
      var updates = {};
      for (var variantId in expectedQtys) {
        if (engravingItems[variantId] !== expectedQtys[variantId]) {
          updates[variantId] = expectedQtys[variantId];
        }
      }
      if (Object.keys(updates).length === 0) {
        checkoutVerified = true;
        submitter.click();
        return;
      }

      // Mismatch — fix then proceed
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          updates: updates
        })
      }).then(function (res) {
        return res.json();
      }).then(function () {
        checkoutVerified = true;
        submitter.click();
      });
    })["catch"](function () {
      // On fetch error proceed anyway — never block checkout
      checkoutVerified = true;
      submitter.click();
    });
  });
});

/**
 * Collection Top Filter Tabs Web Component
 * Compatible with existing collection-filters system
 */
var CollectionTopFilter = /*#__PURE__*/function (_HTMLElement4) {
  _inherits(CollectionTopFilter, _HTMLElement4);
  var _super4 = _createSuper(CollectionTopFilter);
  function CollectionTopFilter() {
    var _this4;
    _classCallCheck(this, CollectionTopFilter);
    _this4 = _super4.call(this);
    _this4.activeTags = new Set();
    _this4.isUpdating = false;
    return _this4;
  }
  _createClass(CollectionTopFilter, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.initActiveStates();
      this.bindEvents();
    }
  }, {
    key: "initActiveStates",
    value: function initActiveStates() {
      var _this5 = this;
      var url = new URL(window.location.href);
      var tagParams = url.searchParams.getAll('filter.p.tag');
      var allButton = this.querySelector('.top-filter-button[data-tag="all"]');
      this.querySelectorAll('.top-filter-button').forEach(function (btn) {
        return btn.classList.remove('is-active');
      });
      this.activeTags.clear();
      if (tagParams.length > 0) {
        tagParams.forEach(function (tag) {
          _this5.activeTags.add(tag);
          var button = _this5.querySelector(".top-filter-button[data-tag=\"".concat(tag, "\"]"));
          if (button) button.classList.add('is-active');
        });
      } else if (allButton) {
        allButton.classList.add('is-active');
      }
    }
  }, {
    key: "bindEvents",
    value: function bindEvents() {
      var _this6 = this;
      this.querySelectorAll('.top-filter-button').forEach(function (button) {
        button.addEventListener('click', _this6.onFilterButtonClick.bind(_this6));
      });

      // Sync active state after theme re-renders the filters section via AJAX
      document.addEventListener('theme:filters:init', function () {
        setTimeout(function () {
          return _this6.initActiveStates();
        }, 50);
      });

      // Sync on browser back/forward (theme uses history.pushState not popstate)
      window.addEventListener('popstate', function () {
        setTimeout(function () {
          return _this6.initActiveStates();
        }, 100);
      });
    }
  }, {
    key: "onFilterButtonClick",
    value: function onFilterButtonClick(event) {
      var _this7 = this;
      event.preventDefault();
      if (this.isUpdating) return;
      var button = event.currentTarget;
      var tagHandle = button.dataset.tag;
      var isAll = tagHandle === 'all';
      var allButton = this.querySelector('.top-filter-button[data-tag="all"]');
      var selectionMode = this.dataset.selectionMode || 'single';
      this.addLoadingState(button);
      if (isAll) {
        this.activeTags.clear();
        this.querySelectorAll('.top-filter-button').forEach(function (btn) {
          return btn.classList.remove('is-active');
        });
        button.classList.add('is-active');
      } else {
        if (selectionMode === 'single') {
          if (button.classList.contains('is-active')) {
            // Clicking active tag deselects → show all
            this.activeTags.clear();
            this.querySelectorAll('.top-filter-button').forEach(function (btn) {
              return btn.classList.remove('is-active');
            });
            if (allButton) allButton.classList.add('is-active');
          } else {
            this.activeTags.clear();
            this.querySelectorAll('.top-filter-button').forEach(function (btn) {
              return btn.classList.remove('is-active');
            });
            this.activeTags.add(tagHandle);
            button.classList.add('is-active');
          }
        } else {
          if (button.classList.contains('is-active')) {
            this.activeTags["delete"](tagHandle);
            button.classList.remove('is-active');
          } else {
            this.activeTags.add(tagHandle);
            button.classList.add('is-active');
          }
          if (this.activeTags.size === 0) {
            if (allButton) allButton.classList.add('is-active');
          } else if (allButton) {
            allButton.classList.remove('is-active');
          }
        }
      }
      this.applyFilters()["finally"](function () {
        _this7.removeLoadingState(button);
      });
    }
  }, {
    key: "applyFilters",
    value: function applyFilters() {
      var _this8 = this;
      return new Promise(function (resolve) {
        _this8.isUpdating = true;

        // The theme's Filters class listens for 'input' events on [data-collection-filters-form]
        // and calls renderSection() which does an AJAX fetch + DOM update (no page reload).
        var filtersForm = document.querySelector('[data-collection-filters-form]');
        if (!filtersForm) {
          // Fallback: full page navigation when form is unavailable (filters disabled)
          var url = _this8.buildFilterUrl();
          window.location.href = url.toString();
          resolve();
          return;
        }

        // After every AJAX re-render the theme calls mobileFiltersScrollLock() which
        // unconditionally adds 'collection__filters--visible', opening the drawer.
        // We use a MutationObserver (microtask timing) to remove it BEFORE any browser
        // paint — eliminating the visible flicker entirely.
        var filtersEl = document.querySelector('[data-collection-filters]');
        var wasFiltersOpen = filtersEl ? filtersEl.classList.contains('collection__filters--visible') : false;
        var observer = null;
        if (!wasFiltersOpen && filtersEl) {
          observer = new MutationObserver(function (mutations) {
            var _iterator = _createForOfIteratorHelper(mutations),
              _step;
            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var mutation = _step.value;
                if (mutation.target.classList.contains('collection__filters--visible')) {
                  // Remove the class immediately (microtask) — no visual flicker of the drawer.
                  mutation.target.classList.remove('collection__filters--visible');
                  // The theme's lock() wraps scrollLock.disablePageScroll() in its own
                  // setTimeout. We must queue our unlock AFTER that macrotask fires,
                  // otherwise enablePageScroll() is a no-op and overflow:hidden gets stuck.
                  setTimeout(function () {
                    document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {
                      bubbles: true
                    }));
                  });
                }
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
          });
          observer.observe(filtersEl, {
            attributes: true,
            attributeFilter: ['class']
          });
        }

        // 1. Uncheck any filter.p.tag checkboxes already present in the facets panel
        filtersForm.querySelectorAll('input[name="filter.p.tag"]').forEach(function (input) {
          if (input.type === 'checkbox' || input.type === 'radio') {
            input.checked = false;
          }
        });

        // 2. Remove our previously injected hidden tag inputs
        filtersForm.querySelectorAll('input[data-top-filter-tag]').forEach(function (input) {
          input.remove();
        });

        // 3. Inject hidden inputs for each active tag
        _this8.activeTags.forEach(function (tag) {
          var input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'filter.p.tag';
          input.value = tag;
          input.setAttribute('data-top-filter-tag', '');
          filtersForm.appendChild(input);
        });

        // 4. theme:filters:init is dispatched by renderFilters() just before
        //    mobileFiltersScrollLock() runs. Stop observing after a short delay
        //    (so the observer stays active long enough to catch mobileFiltersScrollLock)
        //    and do a final safety-net check.
        var onFiltersInit = function onFiltersInit() {
          clearTimeout(fallbackTimer);
          setTimeout(function () {
            if (observer) {
              observer.disconnect();
              observer = null;
            }
            // Safety net: catch any edge case the observer may have missed
            if (!wasFiltersOpen) {
              var el = document.querySelector('[data-collection-filters]');
              if (el && el.classList.contains('collection__filters--visible')) {
                el.classList.remove('collection__filters--visible');
                document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {
                  bubbles: true
                }));
              }
            }
            _this8.isUpdating = false;
            resolve();
          }, 50);
        };
        document.addEventListener('theme:filters:init', onFiltersInit, {
          once: true
        });

        // Fallback: resolve regardless if the AJAX/event never fires
        var fallbackTimer = setTimeout(function () {
          document.removeEventListener('theme:filters:init', onFiltersInit);
          if (observer) {
            observer.disconnect();
            observer = null;
          }
          _this8.isUpdating = false;
          resolve();
        }, 2000);

        // 5. Dispatch 'input' event — triggers the theme's debouncedSubmitEvent (500ms)
        //    → onSubmitHandler → renderSection → AJAX fetch + pushState
        filtersForm.dispatchEvent(new Event('input', {
          bubbles: true
        }));
      });
    }
  }, {
    key: "buildFilterUrl",
    value: function buildFilterUrl() {
      // Fallback URL builder (used when filtersForm is not available)
      var url = new URL(window.location.origin + window.location.pathname);
      var currentParams = new URLSearchParams(window.location.search);
      var _iterator2 = _createForOfIteratorHelper(currentParams.entries()),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _step2$value = _slicedToArray(_step2.value, 2),
            key = _step2$value[0],
            value = _step2$value[1];
          if (!key.startsWith('filter.p.tag') && key !== 'page') {
            url.searchParams.append(key, value);
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      this.activeTags.forEach(function (tag) {
        url.searchParams.append('filter.p.tag', tag);
      });
      return url;
    }
  }, {
    key: "addLoadingState",
    value: function addLoadingState(button) {
      button.style.opacity = '0.6';
      button.style.pointerEvents = 'none';
      button.classList.add('loading');
    }
  }, {
    key: "removeLoadingState",
    value: function removeLoadingState(button) {
      button.style.opacity = '';
      button.style.pointerEvents = '';
      button.classList.remove('loading');
    }
  }, {
    key: "refresh",
    value: function refresh() {
      try {
        this.initActiveStates();
      } catch (error) {
        console.warn('Error refreshing CollectionTopFilter:', error);
      }
    }
  }]);
  return CollectionTopFilter;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('collection-top-filter', CollectionTopFilter);

// Refresh top filters after ajaxinate and facet updates
document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('ajaxinate:loaded', function () {
    document.querySelectorAll('collection-top-filter').forEach(function (el) {
      if (el.refresh) el.refresh();
    });
  });
  document.addEventListener('facet:update', function () {
    setTimeout(function () {
      document.querySelectorAll('collection-top-filter').forEach(function (el) {
        if (el.refresh) el.refresh();
      });
    }, 200);
  });
});

// Suppress ajaxinate classList errors
window.addEventListener('error', function (e) {
  if (e.message && e.message.includes('ajaxinateContainer') && e.message.includes('classList')) {
    console.warn('Ajaxinate classList error caught and handled:', e.message);
    e.preventDefault();
  }
});

/***/ }),

/***/ "./src/scss/main.scss":
/*!****************************!*\
  !*** ./src/scss/main.scss ***!
  \****************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"/assets/main": 0,
/******/ 			"assets/main": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkhandee"] = self["webpackChunkhandee"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	__webpack_require__.O(undefined, ["assets/main"], () => (__webpack_require__("./src/js/main.js")))
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["assets/main"], () => (__webpack_require__("./src/scss/main.scss")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;